export const TYPES = {
  storageService: Symbol('storageService'),
  authService: Symbol('authService'),
};
